<template>
  <span v-if="certStatus">
    <i :class="statusList[certStatus].icon"></i> {{ statusList[certStatus].description }}
  </span>
</template>

<script>

  import CertService from "@/services/cert-service"

  export default {

    name: "CertStatus",

    data() {
      return {
        certStatus: "",
        statusList: CertService.STATUS,
      }
    },

    props: ["status"], 

    created() {

      if (!this.$isSimavet() && this.status !== "finished") {
        this.certStatus = "maintenance"
      } else {
        this.certStatus = this.status
      }
    },
  }
</script>